export const appName = 'project-sales';
